module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/_perform.js
// module id = 580
// module chunks = 168707334958949